import { render, staticRenderFns } from "./department-selector.vue?vue&type=template&id=28033d2b&scoped=true&"
import script from "./department-selector.vue?vue&type=script&lang=js&"
export * from "./department-selector.vue?vue&type=script&lang=js&"
import style0 from "./department-selector.vue?vue&type=style&index=0&id=28033d2b&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "28033d2b",
  null
  
)

export default component.exports